<template>
  <div class="privacity-policies-container pb-xl-6 pb-lg-6 pb-md-2 pb-sm-2 pb-3">
    <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-0 pt-0 px-xl-4 px-lg-4 px-md-4 px-sm-0 px-0 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters>
      <v-col xl="8" lg="9" md="10" sm="11" cols="11" v-if="$vuetify.breakpoint.mdAndUp">
        <div class="text-left headline font-weight-bold section-title mt-1 mb-4">
          Políticas de privacidad
        </div>
      </v-col>
      <v-col xl="8" lg="9" md="10" sm="12" cols="12">
        <v-card class="mx-auto text-left pt-3 pb-7" tile :flat="$vuetify.breakpoint.smAndDown">
          <div class="text-center title font-weight-bold section-title mt-2" v-if="$vuetify.breakpoint.smAndDown">
            Políticas de privacidad
          </div>
          <v-row justify="center" class="pt-xl-4 pt-lg-2 pt-md-4 pt-sm-0 pt-0" no-gutters>
            <v-col xl="11" lg="11" md="11" sm="11" cols="11">
              <v-row justify="center">
                <v-col cols="12">
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Estas políticas de privacidad (las "Políticas de Privacidad")
                      entrarán en vigor desde su aceptación para los nuevos usuarios
                      y están vigentes desde 1º de enero de 2019.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span>
                      La privacidad de la información de los usuarios es muy
                      importante para {{ appName }}. Es por esa razón que se
                      toman las precauciones y recaudos para resguardar su
                      información, utilizando los mecanismos de seguridad
                      informática de protección de la información más completos
                      y eficaces. Como parte normal de nuestra actividad
                      recogemos información sobre nuestros usuarios y visitantes
                      de nuestro sitio Web. Estas Políticas de Privacidad
                      describen la información que {{ appName }} recoge sobre
                      sus usuarios y visitantes y lo que puede hacerse con dicha
                      información. Al inscribirse y/o navegar el sitio Web de
                      {{ appName }}, el usuario y/o el visitante presta su
                      consentimiento inequívoco para que se utilice su
                      información personal de acuerdo a las políticas que se
                      describen a continuación.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span>
                      Este documento es parte integrante de los
                      <a class="blue--text text--darken-3" @click="goToRouteByName('Terms-and-conditions')">
                        Términos y Condiciones de ClubLentes
                      </a>.
                      Mediante la aceptación de los Términos y Condiciones
                      Generales en el momento de la inscripción el usuario
                      acepta las políticas aquí contenidas.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Derechos de acceso, retiro y rectificación de la información personal
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Los usuarios podrán conocer, acceder, retirar y actualizar
                      su Información Personal. Los usuarios garantizan y
                      responden, en cualquier caso, de la veracidad, exactitud,
                      vigencia y autenticidad de la Información Personal
                      facilitada, y se comprometen a mantenerla debidamente
                      actualizada.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Una vez inscrito en {{ appName }}, el usuario podrá
                      revisar y cambiar la información que nos ha proporcionado
                      durante el proceso de inscripción incluyendo:
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <ul class="text--primary">
                      <li>El nombre, apellidos y correo electrónico. Sin perjuicio de los cambios que realice, {{ appName }} conservará la Información Personal anterior por motivos de seguridad y control del fraude.</li>
                      <li>La información de la inscripción como: direcciones, número de teléfono, etc.</li>
                      <li>La clave.</li>
                    </ul>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      En determinados casos, mantendremos en nuestros archivos
                      Información Personal que nos hayas pedido que retiremos, y
                      ello con la finalidad de resolver disputas o
                      reclamaciones, detectar problemas o incidencias y
                      solucionarlos, y dar cumplimiento a lo dispuesto en los
                      Términos y Condiciones Generales por un período de tiempo
                      determinado por la ley o determinado por la finalidad que
                      se persiga. En cualquier caso, la Información Personal de
                      un usuario no será inmediatamente retirada de nuestros
                      archivos por motivos legales y técnicos, incluyendo
                      sistemas de soportes de seguridad. Por tanto, no se debe
                      esperar que toda la Información Personal sea
                      definitivamente borrada de nuestras bases de datos lo cual
                      es entendido y aceptado por los usuarios al aceptar los
                      Términos y Condiciones y las Políticas de Privacidad.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Los usuarios deben actualizar su Información Personal
                      periódicamente conforme vaya cambiando para que puedan ser
                      ubicados cuando realicen una operación. Para hacer
                      cualquier modificación en la información que suministrada
                      en el momento de la Inscripción, se debe ingresar en la
                      sección Mi Cuenta.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} podrá modificar en cualquier momento los
                      términos y condiciones de estas Políticas de Privacidad y
                      confidencialidad y/o las prácticas de envío de e-mails. Si
                      decidimos introducir algún cambio material a nuestras
                      Políticas de Privacidad, te notificaremos publicando una
                      versión actualizada de las Políticas en esta sección o
                      mediante el envío de un correo electrónico o informándolo
                      en la página principal u otras secciones del sitio.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    La información que recabamos
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Lo primero que se debe hacer para disfrutar de los
                      servicios de {{ appName }} es inscribirse, suministrando
                      ciertos datos personales ("Información Personal")
                      completos y exactos. Podremos solicitar, recabar y
                      almacenar la siguiente Información Personal: nombre de
                      usuario para operar en el sitio de {{ appName }} , nombre,
                      número de documento, información física de contacto (como
                      número telefonico, direcciones, dirección de correo
                      electrónico, etc.). {{ appName }} podrá confirmar los
                      datos personales suministrados acudiendo a entidades
                      públicas, compañías especializadas o centrales de riesgo,
                      para lo cual nos autorizas expresamente. La información
                      que {{ appName }} obtenga de estas entidades será tratada
                      en forma confidencial.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      El Usuario que se registre en {{ appName }} a través de su
                      cuenta personal en una red social ("Cuenta Personal"), o
                      de cualquier modo acceda a {{ appName }} a través de su
                      Cuenta Personal, consiente expresamente que {{ appName }}:
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <ul class="text--primary">
                      <li>Tenga acceso, en cualquier momento, a la totalidad de la información contenida en su Cuenta Personal, incluyendo en particular, pero sin limitación, a su Información Personal, información sobre sus intereses, gustos, contactos y cualquier otro contenido alojado en su Cuenta Persona.</li>
                      <li>Incluya en dicha cuenta, mensajes, fotografías, videos y cualquier otro tipo de contenido.</li>
                      <li>Envíe al correo electrónico del Usuario vinculado a la Cuenta Personal, información o mensajes con la finalidad descripta en la sección "Uso que hacemos de la Información" abajo.</li>
                    </ul>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Se acuerda expresamente que en cualquier momento el
                      usuario inscrito en {{ appName }} podrá solicitar la baja o
                      cierre de su solicitud de inscripción, y/o el cierre de su
                      cuenta o eliminación de su cuenta e información de la base
                      de datos de {{ appName }}. Por favor revisa la sección
                      "Derechos de acceso, cancelación y rectificación de la
                      información personal" abajo.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} recoge y almacena automáticamente cierta
                      información sobre la actividad de los usuarios y
                      visitantes dentro de su sitio web. Tal información puede
                      incluir la URL de la que provienen (estén o no en nuestro
                      sitio web), a qué URL acceden seguidamente (estén o no en
                      nuestro sitio web), qué navegador están usando, y sus
                      direcciones IP. También las páginas visitadas, las
                      búsquedas realizadas, las publicaciones, compras o ventas,
                      calificaciones entre otra información podrá ser almacenada
                      y retenida.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Si los usuarios nos envían correspondencia sean correos
                      electrónicos o cartas, o si otros usuarios o terceros nos
                      envían correspondencia sobre las actividades o sobre los
                      mensajes de otros usuarios en nuestro sitio, podemos
                      recoger y almacenar tal Información Personal, incluyendo
                      direcciones de e-mail.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Uso que hacemos de la información
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Para suministrar un excelente servicio y para que los
                      usuarios puedan realizar operaciones en forma ágil y
                      segura, {{ appName }} requiere cierta información de carácter
                      personal, incluyendo dirección de e-mail. La recolección
                      de información nos permite ofrecer a los usuarios
                      servicios y funcionalidades que se adecuen mejor a sus
                      necesidades y personalizar nuestros servicios para hacer
                      que sus experiencias con {{ appName }} sean lo más cómodas
                      posible. La Información Personal que recabamos tiene las
                      siguientes finalidades:
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <ul class="text--primary">
                      <li>Ayudar al comprador a adquirir un producto.</li>
                      <li>Desarrollar estudios internos sobre los intereses, comportamientos y demografía de los usuarios para comprender mejor sus necesidades e intereses y ofrecer mejores servicios o proveerles información relacionada.</li>
                      <li>Enviar información o mensajes por e-mail sobre nuevos servicios, mostrar publicidad o promociones, banners, de interés para nuestros usuarios, noticias sobre {{ appName }}, además de la información expresamente autorizada en la sección de preferencias. Si el usuario lo prefiere, puede solicitar que lo excluyan de las listas para el envío de información promocional o publicitaria. Por favor aprende a hacerlo la sección "Cambio de preferencias de e-mail" abajo.</li>
                      <li>Enviar información o avisos por mensajes cortos de texto (SMS) al teléfono celular suministrado por el usuario a {{ appName }}. Los mensajes cortos de texto podrán contener avisos publicitarios y/o promocionales de {{ appName }} y/o terceros, así como información sobre los servicios de {{ appName }}.</li>
                      <li>Suministrar la información personal de los usuarios a las entidades que intervengan en la resolución de disputas, tales como: Compañías de Seguros o Tribunales de Arbitraje o tribunales competentes para solucionar tales disputas.</li>
                    </ul>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Confidencialidad de la información
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Una vez inscrito en su sitio Web, {{ appName }} no venderá,
                      alquilará o compartirá la Información Personal excepto en
                      las formas establecidas en estas políticas. Sin perjuicio
                      de ello, el usuario consiente en forma expresa que
                      {{ appName }} transfiera total o parcialmente la Información
                      Personal a cualquiera de las sociedades controladas,
                      controlantes y/o vinculadas con {{ appName }}, a cualquier
                      título y en el momento, forma y condiciones que estime
                      pertinentes. Haremos todo lo que esté a nuestro alcance
                      para proteger la privacidad de la información. Puede
                      suceder que en virtud de órdenes judiciales, o de
                      regulaciones legales, nos veamos compelidos a revelar
                      información a las autoridades o terceras partes bajo
                      ciertas circunstancias, o bien en casos que terceras
                      partes puedan interceptar o acceder a cierta información o
                      transmisiones de datos en cuyo caso {{ appName }} no responderá
                      por la información que sea revelada.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Nombre de usuario
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Para interactuar dentro del sitio, los usuarios deben
                      utilizar un nombre de usuario que los identificará.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Clave personal
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Para acceder a los servicios reservados únicamente para
                      los usuarios debidamente inscritos los usuarios dispondrán
                      de una clave personal. Con ella podrán comprar, calificar,
                      entre otras actividades. Esta clave deben mantenerla bajo
                      absoluta confidencialidad y, en ningún caso, deberán
                      revelarla o compartirla con otras personas.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      El usuario será responsable de todos los actos que tengan
                      lugar mediante el uso de su Nombre de usuario y Clave. Si
                      por cualquier razón un usuario creyera que alguien puede
                      conocer su clave, deberá modificarla ingresando desde el
                      menú de navegación en Mi Cuenta y hacer clic en Cambiar
                      contraseña.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Cookies
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      El usuario y el visitante del sitio Web de {{ appName }} conoce y
                      acepta que {{ appName }} podrá utilizar un sistema de seguimiento
                      mediante la utilización de cookies (las "Cookies"). Las
                      Cookies son pequeños archivos que se instalan en el disco
                      rígido, con una duración limitada en el tiempo que ayudan a
                      personalizar los servicios. También ofrecemos ciertas
                      funcionalidades que sólo están disponibles mediante el
                      empleo de Cookies. Las Cookies se utilizan con el fin de
                      conocer los intereses, el comportamiento y la demografía de
                      quienes visitan o son usuarios de nuestro Sitio Web y de esa
                      forma, comprender mejor sus necesidades e intereses y darles
                      un mejor servicio o proveerle información relacionada.
                      También usaremos la información obtenida por intermedio de
                      las Cookies para analizar las páginas navegadas por el
                      visitante o usuario, las búsquedas realizadas, mejorar
                      nuestras iniciativas comerciales ,mostrar publicidad o
                      promociones, banners de interés, noticias sobre {{ appName }},
                      personalizar dichos contenidos, presentación y servicios;
                      también podremos utilizar Cookies para promover y hacer
                      cumplir las reglas y seguridad del sitio. {{ appName }} podrá
                      agregar Cookies en los e-mails que envíe para medir la
                      efectividad de las promociones.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Utilizamos adicionalmente las Cookies para que el usuario no
                      tenga que introducir su clave tan frecuentemente durante una
                      sesión de navegación, también para contabilizar y corroborar
                      las inscripciones, la actividad del usuario y otros
                      conceptos para acuerdos comerciales, siempre teniendo como
                      objetivo de la instalación de las Cookies, el beneficio del
                      usuario que la recibe, y no será usado con otros fines
                      ajenos a {{ appName }}.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Se establece que la instalación, permanencia y existencia de
                      las Cookies en el computador del usuario depende de su
                      exclusiva voluntad y puede ser eliminada de su computador
                      cuando el usuario así lo desee.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Por último, {{ appName }} almacena cookies para poder ofrecer una
                      experiencia más interactiva en el sitio, basada en las
                      acciones del usuario. El usuario puede, en cualquier
                      momento, eliminar las cookies almacenadas, configurar el
                      navegador para que solicite aprobación antes de almacenar
                      cookies o directamente evitar que se almacenen cookies.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      Se aclara expresamente que estas políticas cubre la
                      utilización de Cookies por este sitio y no la utilización de
                      Cookies por parte de anunciantes. Nosotros no controlamos el
                      uso de Cookies por terceros.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} podrá suspender o inhabilitar definitivamente a
                      aquellos usuarios que violen esta política.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Orden de autoridades competentes - Requerimientos Legales
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} coopera con las autoridades competentes y con otros
                      terceros para garantizar el cumplimiento de las leyes, por
                      ejemplo en materia de protección de derechos de propiedad
                      industrial e intelectual, prevención del fraude y otras
                      materias.
                    </span>
                  </div>
                  <div class="body-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} podrá revelar la Información Personal de sus
                      usuarios bajo requerimiento de la autoridades judiciales o
                      gubernamentales competentes para efectos de investigaciones
                      conducidas por ellas, aunque no exista una orden ni una
                      citación ejecutiva o judicial, o por ejemplo (y sin
                      limitación a este supuesto) cuando se trate de
                      investigaciones de carácter penal o de fraude. En tales
                      situaciones, {{ appName }} colaborará con las autoridades
                      competentes con el fin de salvaguardar la integridad y la
                      seguridad de la Comunidad y la de sus usuarios.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} puede (y los usuarios lo autorizan expresamente)
                      comunicar cualquier Información Personal sobre sus usuarios
                      con la finalidad de cumplir la normativa aplicable y
                      cooperar con las autoridades competentes en la medida en que
                      discrecionalmente lo entendamos necesario y adecuado en
                      relación con cualquier investigación de un ilícito o un
                      fraude u otra actividad que sea ilegal o que pueda exponer a
                      {{ appName }} o a sus usuarios a cualquier responsabilidad legal.
                      Además, podemos (y los usuarios lo autorizan expresamente)
                      comunicar su nombre, nombre de usuario, direcciones, número
                      de teléfono, dirección de correo electrónico, etc. Este
                      derecho será ejercido por {{ appName }} a efectos de cooperar con
                      el cumplimiento y ejecución de la ley, independientemente
                      que no exista una orden judicial o administrativa al efecto.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Seguridad. Almacenamiento de la información
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} está obligado a cumplir con toda la normativa
                      aplicable en materia de medidas de seguridad aplicables a la
                      Información Personal. Adicionalmente, {{ appName }} usa los
                      estándares de la industria entre materia de protección de la
                      confidencialidad de su Información Personal, incluyendo, en
                      otras medidas, cortafuegos ("firewalls") y Secure Socket
                      Layers ("SSL"). {{ appName }} considera a los datos de sus
                      usuarios como un activo que debe ser protegido de cualquier
                      pérdida o acceso no autorizado. Empleamos diversas técnicas
                      de seguridad para proteger tales datos de accesos no
                      autorizados por usuarios de dentro o fuera de nuestra
                      compañía. Sin embargo, es necesario tener muy en cuenta que
                      la seguridad perfecta no existe en Internet.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Por ello, {{ appName }} no se hace responsable por
                      interceptaciones ilegales o violación de sus sistemas o
                      bases de datos por parte de personas no autorizadas.
                      {{ appName }}, tampoco se hace responsable por la indebida
                      utilización de la información obtenida por esos medios.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Responsable de protección de datos
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                      Nuestro Responsable de Protección de Datos es el
                      Sr. {{ owner }}, a quien podrás contactar mediante los
                      medios detallados más abajo.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Área encargada de peticiones, consultas y reclamos de datos personales
                  </div>
                  <div class="body-2 mt-2 mb-4 text-muted font-weight-light">
                    <span class="text--primary">
                      El área encargada de atender las peticiones, consultas y
                      reclamos de los titulares para ejercer sus derechos a
                      conocer, actualizar, rectificar y suprimir sus datos y
                      revocar su autorización es el Área de Atención al Cliente.
                      Para hacer cualquier consulta, reclamo y/o petición relativa
                      a tus datos personales, podrás hacerlo por correo a
                      {{ email }}.
                    </span>
                  </div>
                  <div class="body-2 text-muted font-weight-light">
                    <span class="text--primary">
                      {{ appName }} responderá a la solicitud en el plazo estipulado
                      por la Ley 1581 de 2012. Cuando no fuere posible atender tu
                      consulta dentro de dicho término, te avisaremos
                      oportunamente, expresando los motivos de la demora y
                      señalando la fecha en que será atendida.
                    </span>
                  </div>
                </v-col>
                <v-col cols="12">
                  <div class="body-1 text-muted">
                    Vigencia de los datos
                  </div>
                  <div class="body-2 mt-2 text-muted font-weight-light">
                    <span class="text--primary">
                    Los datos de los usuarios estarán en nuestra base de datos
                    mientras sea necesario para cumplir los usos y finalidades
                    que se mencionan en este documento o en los Términos y
                    Condiciones.
                    </span>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import navigationMixin from '@/mixins/navigation'
import { APP_NAME, EMAIL, OWNER } from '@/config/local-info'

export default {
  mixins: [navigationMixin],
  data () {
    return {
      appName: APP_NAME,
      email: EMAIL,
      owner: OWNER
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .text-muted {
    line-height: 1.75em;
  }

  .privacity-policies-container{
    height: 100%;
  }

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .privacity-policies-container{
      background-color: #FFFFFF;
    }
  }
</style>
